import { c as _c } from "react/compiler-runtime";
import 'nouislider/distribute/nouislider.css';
import { checkLengthForInput } from '@lib/tools/_check-length-for-input';
import formatLongPrice from '@lib/tools/_format-long-price';
import Nouislider from 'nouislider-react';
import { useRef } from 'react';
import styles from './NumberSliderEqualizer.module.scss';
import getWidthForInput from './utils/_get-width-for-input';
import useInputValue from './utils/useInputValue';
const NumberSliderEqualizer = t0 => {
  const $ = _c(61);
  const {
    min,
    max,
    start,
    step,
    slider,
    textValue,
    percent,
    disabled,
    paddingSlider,
    withPercent,
    switchPercent: t1,
    maxAllowedValue,
    onChange,
    onUpdateSlider,
    onChangeSlider
  } = t0;
  const switchPercent = t1 === undefined ? false : t1;
  const inputRef = useRef(null);
  const {
    inputValue,
    setInputValue,
    inputWidth,
    setInputWidth
  } = useInputValue(textValue, Number(max), switchPercent);
  let handleBlur;
  if ($[0] !== inputValue || $[1] !== max || $[2] !== maxAllowedValue || $[3] !== min || $[4] !== onChange || $[5] !== setInputValue || $[6] !== setInputWidth || $[7] !== switchPercent || $[8] !== textValue || $[9] !== withPercent) {
    handleBlur = event => {
      const value = event.target.value.replace(/\s/g, "");
      const numberValue = Number(value);
      if (value === "") {
        setInputValue(formatLongPrice(textValue));
        return;
      }
      if (!withPercent) {
        if (Number.isNaN(numberValue) || numberValue < Number(min) || numberValue > Number(max)) {
          setInputValue(formatLongPrice(textValue));
        } else {
          onChange?.(numberValue);
        }
      } else {
        handlePercentInput(numberValue);
      }
      setInputWidth(checkLengthForInput(inputValue));
    };
    const handlePercentInput = numberValue_0 => {
      const valueInRubles = switchPercent ? numberValue_0 / 100 * Number(max) : numberValue_0;
      if (numberValue_0 < Number(min) || valueInRubles > Number(maxAllowedValue)) {
        setInputValue(switchPercent ? Math.floor(Number(textValue) / Number(max) * 100) : formatLongPrice(textValue));
      } else {
        onChange?.(numberValue_0);
      }
    };
    $[0] = inputValue;
    $[1] = max;
    $[2] = maxAllowedValue;
    $[3] = min;
    $[4] = onChange;
    $[5] = setInputValue;
    $[6] = setInputWidth;
    $[7] = switchPercent;
    $[8] = textValue;
    $[9] = withPercent;
    $[10] = handleBlur;
  } else {
    handleBlur = $[10];
  }
  let t2;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event_0 => {
      if (event_0.key === "Enter") {
        inputRef.current?.blur();
      }
      const isValidKey = /^[\d\s]$/.test(event_0.key) || ["Backspace", "ArrowLeft", "ArrowRight", "Delete"].includes(event_0.key);
      if (!isValidKey) {
        event_0.preventDefault();
      }
    };
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const handleKeyDown = t2;
  const t3 = String(max)?.length || 10;
  let t4;
  if ($[12] !== inputWidth || $[13] !== t3) {
    t4 = getWidthForInput(inputWidth, t3);
    $[12] = inputWidth;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = {
      width: t4
    };
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== setInputValue) {
    t6 = e => setInputValue(e.target.value);
    $[17] = setInputValue;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== handleBlur || $[20] !== inputValue || $[21] !== t5 || $[22] !== t6) {
    t7 = <input ref={inputRef} style={t5} onBlur={handleBlur} onChange={t6} onKeyDown={handleKeyDown} className={styles.rangeSlider__input} value={inputValue} />;
    $[19] = handleBlur;
    $[20] = inputValue;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== slider || $[25] !== switchPercent) {
    t8 = slider !== "creditTerm" && <p className={styles.rangeSlider__percent}>{switchPercent ? "%" : "\u20BD"}</p>;
    $[24] = slider;
    $[25] = switchPercent;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <div className={styles.rangeSlider__inputBox_block}>{t7}{t8}</div>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== percent || $[31] !== switchPercent || $[32] !== textValue || $[33] !== withPercent) {
    t10 = withPercent && <span className={styles.rangeSlider__percent}>{switchPercent ? formatLongPrice(textValue) + " \u20BD" : percent + "%"}</span>;
    $[30] = percent;
    $[31] = switchPercent;
    $[32] = textValue;
    $[33] = withPercent;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t10) {
    t11 = <div>{t10}</div>;
    $[35] = t10;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t11 || $[38] !== t9) {
    t12 = <div className={styles.rangeSlider__inputBox}>{t9}{t11}</div>;
    $[37] = t11;
    $[38] = t9;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [true, false];
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  const t14 = Number(min);
  const t15 = Number(max);
  let t16;
  if ($[41] !== t14 || $[42] !== t15) {
    t16 = {
      min: t14,
      max: t15
    };
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== onUpdateSlider || $[45] !== slider) {
    t17 = values => onUpdateSlider(slider, values);
    $[44] = onUpdateSlider;
    $[45] = slider;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== onChangeSlider || $[48] !== slider) {
    t18 = values_0 => onChangeSlider(slider, values_0);
    $[47] = onChangeSlider;
    $[48] = slider;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== disabled || $[51] !== paddingSlider || $[52] !== start || $[53] !== step || $[54] !== t16 || $[55] !== t17 || $[56] !== t18) {
    t19 = <Nouislider padding={paddingSlider} disabled={disabled} connect={t13} range={t16} step={step} start={start} onUpdate={t17} onChange={t18} />;
    $[50] = disabled;
    $[51] = paddingSlider;
    $[52] = start;
    $[53] = step;
    $[54] = t16;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] !== t12 || $[59] !== t19) {
    t20 = <div className={styles.rangeSlider}>{t12}{t19}</div>;
    $[58] = t12;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  return t20;
};
export default NumberSliderEqualizer;